import { TranslateLoader } from "@ngx-translate/core";
import { TranslationService } from "../services/translation.service";
import { from, Observable, of, switchMap } from "rxjs";
import { StorageService } from "../services/storage.service";
import { inject } from "@angular/core";

export class TranslationLoader implements TranslateLoader {

    constructor(private translationService: TranslationService) { }
storageService = inject(StorageService);
     getTranslation(lang: string): Observable<any> {
    return from(this.storageService.getItemIonic(`translations_${lang}`)).pipe(
      switchMap((cached) => {
        if (cached) {
          return of(cached);
        }
        return this.translationService.getTranslation(lang);
      })
    );
  }
}

export function HttpLoaderFactory(service: TranslationService) {
    return new TranslationLoader(service);
}